import { Box, CircularProgress, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

type LoadingSpinnerProps = {
  fullScreen?: boolean;
};

const LoadingSpinner = ({ fullScreen = false }: LoadingSpinnerProps) => {
  const theme = useTheme();

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: theme.palette.background.default,
          zIndex: 9999,
        }}
      >
        <LoadingAnimation />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '85vh',
        py: 8,
      }}
    >
      <LoadingAnimation />
    </Box>
  );
};

// Animated loading component
const LoadingAnimation = () => {
  const theme = useTheme();

  return (
    <Box sx={{ textAlign: 'center' }}>
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: theme.palette.primary.main,
            mb: 2,
          }}
        />
      </motion.div>
      <motion.div
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.3 }}
      >
        <Box
          component="span"
          sx={{
            display: 'block',
            fontSize: '1rem',
            color: theme.palette.text.secondary,
            mt: 2,
          }}
        >
          Loading...
        </Box>
      </motion.div>
    </Box>
  );
};

export default LoadingSpinner;
